document.addEventListener("DOMContentLoaded", function () {
    const languageSwitcher = document.querySelector('.wpml-ls-current-language');
    if (languageSwitcher) {
        languageSwitcher.addEventListener('click', function (e) {
            e.preventDefault(); // Förhindra standardlänk-klick
            const subMenu = this.querySelector('.sub-menu');
            if (subMenu) {
                const isVisible = subMenu.style.display === 'block';
                subMenu.style.display = isVisible ? 'none' : 'block';
            }
        });
    }

    const ua = navigator.userAgent;
    const isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(ua);
    const isAppleDevice = /(Macintosh|iPad)/i.test(ua); // includes iPads with desktop UA

    if (isSafari && isAppleDevice) {
        document.documentElement.classList.add("mac-safari");
    }
    
});
